import React from "react";
import "./ServicesPage.css";
import Header from "../components/Header";
import ServicesPagecontent from "../components/ServicesPagecontent";
import ReadySection from "../components/ReadySection";

export default function ServicesPage() {
    return (
        <>
            <Header />
            <ServicesPagecontent />
            <ReadySection />
        </>
    );
}
